import React, { useState } from 'react'
import ModalBox from './ModalBox'
import maxineStarInfoImg from '../../Assets/Images/maxineStarInfo.png'
import infoModalImg from '../../Assets/Images/infoModal.png'
import chatInfoModalImg from '../../Assets/Images/chat-infoModal.png'

export function InfoModal(props) {
    const [showModal, setShowModal] = useState(false);
 
    const getImage = () => {
        switch(props.type) {
            case 'maxine_star':
                return maxineStarInfoImg;
            case 'payment_permission':
                return props.dialogClassName==='chat-moda' ? chatInfoModalImg : infoModalImg;
            default:
                return props.dialogClassName==='chat-moda' ? chatInfoModalImg : infoModalImg;
        }
    }

  return (
    <>
    <i className="fa-solid fa-circle-info primary" onClick={()=>setShowModal(true)}></i>
    <ModalBox
      isShow={showModal}
      handleClose={()=>setShowModal(false)}
      modalSize="md"
      hasData={true}
      hideClose={true}
      dialogClassName={props.dialogClassName}
    >
        <div className="text-center">
        <img className="mb-3 w-50" src={getImage()}/>
      <h3 className="mt-4 mb-2 white d-block">{props.title}</h3>
      <p>{props.description}</p>
      </div>
      <div className="mt-4">
        
        <button
          type="button"
          className="btn btn-primary rounded-pill w-100 p-2"
          onClick={()=>setShowModal(false)}
        >
          Close
        </button>
      </div>
    </ModalBox>
    </>
  )
}

export function MaxineStarInfo() {
    const [showModal, setShowModal] = useState(false);

  return (
    <>
    <i className="fa-solid fa-circle-info primary" onClick={()=>setShowModal(true)}></i>
    <ModalBox
      isShow={showModal}
      handleClose={()=>setShowModal(false)}
      modalSize="md"
      hasData={true}
      hideClose={true}
    >
        <div className="text-center">
        <img className="mb-3 w-50" src={maxineStarInfoImg}/>
      <h3 className="mt-4 mb-2 white d-block">Maxine Star</h3>
      <p>You can order services for upto 5 relationships under Maxine star category</p>
      </div>
      <div className="mt-4">
        
        <button
          type="button"
          className="btn btn-primary rounded-pill w-100 p-2"
          onClick={()=>setShowModal(false)}
        >
          Close
        </button>
      </div>
    </ModalBox>
    </>
  )
}

export function PaymentPermissionsInfo() {
    const [showModal, setShowModal] = useState(false);

  return (
    <>
    <i className="fa-solid fa-circle-info primary" onClick={()=>setShowModal(true)}></i>
    <ModalBox
      isShow={showModal}
      handleClose={()=>setShowModal(false)}
      modalSize="md"
      hasData={true}
      hideClose={true}
    >
        <div className="text-center">
        <img className="mb-3 w-50" src={infoModalImg}/>
      <h3 className="mt-4 mb-2 white d-block">Payment Permissions</h3>
      <p>By enabling payment permissions, you can permit this user to order services for you, using your payment methods (Wallet Balance / Credit Card).</p>
      </div>
      <div className="mt-4">
        
        <button
          type="button"
          className="btn btn-primary rounded-pill w-100 p-2"
          onClick={()=>setShowModal(false)}
        >
          Close
        </button>
      </div>
    </ModalBox>
    </>
  )
}